/*
  Favorite ONE: lista de dorinte, fara aplicatie.

  Lista sta in browserul clientului (localStorage), deci merge si fara cont.
  Scriptul pune singur trei lucruri pe pagina, ca sa nu atingem fisierele
  mari ale temei:
    1. o inima in antet, cu numarul de produse salvate, care deschide panoul;
    2. o inima pe fiecare card de produs ONE ([data-one-card]);
    3. un buton „Salvează la favorite" sub titlul fisei de produs.
  Panoul citeste produsele din /products/<handle>.js, deci pretul si poza
  sunt mereu cele de azi, nu cele de la momentul salvarii.

  Fiecare adaugare publica evenimentul one:wishlist_add (Shopify customer
  events), ca sa poata fi folosit mai tarziu in pixeli si audiente.
*/
(function () {
  'use strict';
  if (window.__oneFav) return;
  window.__oneFav = true;

  var KEY = 'one_favorite_v1';
  var MAX = 60;

  function citeste() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (x) { return x && x.h; }) : [];
    } catch (e) { return []; }
  }
  function scrie(lista) {
    try { localStorage.setItem(KEY, JSON.stringify(lista.slice(0, MAX))); } catch (e) {}
    actualizeaza();
  }
  function are(h) { return citeste().some(function (x) { return x.h === h; }); }
  function comuta(h, titlu) {
    var lista = citeste();
    var exista = lista.some(function (x) { return x.h === h; });
    if (exista) {
      lista = lista.filter(function (x) { return x.h !== h; });
    } else {
      lista.unshift({ h: h, t: Date.now() });
      publica('one:wishlist_add', { handle: h, title: titlu || '' });
    }
    scrie(lista);
    anunta(exista ? 'Scos din favorite' : 'Salvat la favorite');
    return !exista;
  }
  function publica(nume, date) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(nume, date); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent(nume, { detail: date })); } catch (e) {}
  }

  var INIMA = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.1 3.4 4.5 7 4.5c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 3.6 0 5.5 3.6 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z" fill="currentColor" fill-opacity="var(--fav-fill,0)" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>';

  function handleDin(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* Mesaj scurt, citit si de cititoarele de ecran. */
  var toast;
  function anunta(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'one-fav-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 1800);
  }

  function stareButon(btn, h) {
    var on = are(h);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Scoate din favorite' : 'Salvează la favorite');
    var et = btn.querySelector('[data-fav-text]');
    if (et) et.textContent = on ? 'Salvat la favorite' : 'Salvează la favorite';
  }

  /* 1. Inima de pe card */
  function carduri(root) {
    (root || document).querySelectorAll('[data-one-card]').forEach(function (card) {
      if (card.querySelector('.one-fav')) return;
      var link = card.querySelector('.one-card__name, a[href*="/products/"]');
      var h = handleDin(link && link.getAttribute('href'));
      if (!h) return;
      var titlu = link ? link.textContent.trim() : '';
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'one-fav';
      b.dataset.favHandle = h;
      b.innerHTML = INIMA;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        comuta(h, titlu);
      });
      card.appendChild(b);
      stareButon(b, h);
    });
  }

  /* 2. Butonul de pe fisa de produs */
  function fisa() {
    var h = handleDin(location.pathname);
    if (!h || document.querySelector('.one-fav-pdp')) return;
    var titlu = document.querySelector('main h1');
    if (!titlu) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'one-fav-pdp';
    b.dataset.favHandle = h;
    b.innerHTML = INIMA + '<span data-fav-text>Salvează la favorite</span>';
    b.addEventListener('click', function () { comuta(h, titlu.textContent.trim()); });
    titlu.insertAdjacentElement('afterend', b);
    stareButon(b, h);
  }

  /* 3. Inima din antet si panoul */
  var hdr, panou, lista_el;
  function antet() {
    if (hdr) return;
    var cos = document.querySelector('header-actions cart-icon');
    var tinta = cos ? cos.closest('button, a') : null;
    hdr = document.createElement('button');
    hdr.type = 'button';
    hdr.className = 'one-fav-h' + (tinta ? ' header-actions__action button-unstyled' : ' one-fav-h--plutitor');
    hdr.setAttribute('aria-label', 'Favorite');
    hdr.setAttribute('aria-haspopup', 'dialog');
    hdr.innerHTML = INIMA + '<span class="one-fav-h__n" data-fav-count hidden></span>';
    hdr.addEventListener('click', deschide);
    if (tinta) tinta.parentNode.insertBefore(hdr, tinta);
    else document.body.appendChild(hdr);
  }

  function construiestePanou() {
    if (panou) return;
    panou = document.createElement('div');
    panou.className = 'one-fav-panou';
    panou.hidden = true;
    panou.innerHTML =
      '<div class="one-fav-panou__fundal" data-fav-close></div>' +
      '<aside class="one-fav-panou__corp" role="dialog" aria-modal="true" aria-labelledby="one-fav-titlu">' +
        '<header class="one-fav-panou__cap">' +
          '<h2 id="one-fav-titlu">Favorite</h2>' +
          '<button type="button" class="one-fav-panou__x" data-fav-close aria-label="Închide">×</button>' +
        '</header>' +
        '<p class="one-fav-panou__nota">Lista se păstrează în acest browser. Revino oricând, produsele rămân aici.</p>' +
        '<ul class="one-fav-lista" data-fav-list></ul>' +
      '</aside>';
    document.body.appendChild(panou);
    lista_el = panou.querySelector('[data-fav-list]');
    panou.addEventListener('click', function (e) {
      if (e.target.closest('[data-fav-close]')) inchide();
      var sterge = e.target.closest('[data-fav-remove]');
      if (sterge) { comuta(sterge.dataset.favRemove); randeaza(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panou.hidden) inchide(); });
  }

  var ultimFocus;
  function deschide() {
    construiestePanou();
    ultimFocus = document.activeElement;
    panou.hidden = false;
    document.documentElement.classList.add('one-fav-deschis');
    randeaza();
    var x = panou.querySelector('.one-fav-panou__x');
    if (x) x.focus();
  }
  function inchide() {
    panou.hidden = true;
    document.documentElement.classList.remove('one-fav-deschis');
    if (ultimFocus && ultimFocus.focus) ultimFocus.focus();
  }

  function lei(bani) {
    return (bani / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function randeaza() {
    if (!lista_el) return;
    var lista = citeste();
    if (!lista.length) {
      lista_el.innerHTML = '<li class="one-fav-gol">Nu ai salvat încă niciun produs. Apasă inima de pe un produs ca să îl găsești aici mai târziu.</li>';
      return;
    }
    lista_el.innerHTML = lista.map(function (x) {
      return '<li class="one-fav-item" data-fav-item="' + esc(x.h) + '"><span class="one-fav-item__schelet"></span></li>';
    }).join('');
    lista.forEach(function (x) {
      fetch('/products/' + encodeURIComponent(x.h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
        .then(function (p) {
          var li = lista_el.querySelector('[data-fav-item="' + CSS.escape(x.h) + '"]');
          if (!li) return;
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          var pret = p.price > 0 ? ((p.variants && p.variants.length > 1 && p.price_varies ? 'de la ' : '') + lei(p.price)) : 'Preț la cerere';
          li.innerHTML =
            '<a class="one-fav-item__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
            '<div class="one-fav-item__txt">' +
              '<a class="one-fav-item__nume" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<span class="one-fav-item__pret">' + pret + (p.available ? '' : ' · indisponibil acum') + '</span>' +
            '</div>' +
            '<button type="button" class="one-fav-item__sterge" data-fav-remove="' + esc(x.h) + '" aria-label="Scoate ' + esc(p.title) + ' din favorite">×</button>';
        })
        .catch(function () {
          /* Produsul nu mai exista sau nu mai e publicat: il scoatem din lista. */
          scrie(citeste().filter(function (y) { return y.h !== x.h; }));
          var li = lista_el.querySelector('[data-fav-item="' + CSS.escape(x.h) + '"]');
          if (li) li.remove();
        });
    });
  }

  function actualizeaza() {
    var n = citeste().length;
    document.querySelectorAll('[data-fav-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
    document.querySelectorAll('[data-fav-handle]').forEach(function (b) { stareButon(b, b.dataset.favHandle); });
  }

  function porneste() {
    antet();
    carduri();
    fisa();
    actualizeaza();
    var grile = document.querySelectorAll('[data-one-grid], .one-related, main');
    if ('MutationObserver' in window && grile.length) {
      var mo = new MutationObserver(function () { carduri(); });
      mo.observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    }
    window.addEventListener('storage', function (e) { if (e.key === KEY) actualizeaza(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste);
  else porneste();
})();
